import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConfigService } from './global-config.service';
import { 
  DashboardFilters, 
  DocumentCountsDto, 
  FilteredDashboardData, 
  GeneralDashboardData, 
  NewDashboardResponse, 
  ProcedureRanking, 
  RankingItemDto 
} from '../models/dashboard.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/bi/dashboard';
  }

  constructor(
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) { }

  private buildParams(filters: DashboardFilters): HttpParams {
    let params = new HttpParams()
      .set('clinic_id', filters.clinic_id)
      .set('initial_date', filters.initial_date)
      .set('final_date', filters.final_date);

    if (filters.responsible_id) {
      params = params.set('responsible_id', filters.responsible_id);
    }
    if (filters.module) {
      params = params.set('module', filters.module);
    }
    return params;
  }

  /** @deprecated Use getFilteredData + getGeneralData instead */
  getDashboardData(filters: DashboardFilters): Observable<NewDashboardResponse> {
    return this.http.get<NewDashboardResponse>(this.baseUrl, { params: this.buildParams(filters) });
  }

  getFilteredData(filters: DashboardFilters): Observable<FilteredDashboardData> {
    return this.http.get<FilteredDashboardData>(`${this.baseUrl}/filtered`, { params: this.buildParams(filters) });
  }

  getGeneralData(filters: DashboardFilters): Observable<GeneralDashboardData> {
    return this.http.get<GeneralDashboardData>(`${this.baseUrl}/general`, { params: this.buildParams(filters) });
  }

  getDocuments(filters: DashboardFilters): Observable<DocumentCountsDto> {
    return this.http.get<DocumentCountsDto>(`${this.baseUrl}/documents`, { params: this.buildParams(filters) });
  }

  getProcedures(filters: DashboardFilters): Observable<RankingItemDto[]> {
    return this.http.get<RankingItemDto[]>(`${this.baseUrl}/procedures`, { params: this.buildParams(filters) });
  }

  getOrigins(filters: DashboardFilters): Observable<[string, number][]> {
    return this.http.get<[string, number][]>(`${this.baseUrl}/origins`, { params: this.buildParams(filters) });
  }

  exportDashboardCsv(filters: DashboardFilters): Observable<Blob> {
    const url = this.baseUrl + '/export';
    return this.http.get(url, { params: this.buildParams(filters), responseType: 'blob' });
  }
}
